<template>
  <div class="accordion-controller">
    <AdminTableHeader v-if="data.type === 'admin' && global.screenWidth >= 1008" />
    <SewistTableHeader v-if="data.type === 'sewist' && global.screenWidth >= 1008" />
    <div class="accordion" v-for="(accordionItem, index) in data.items" :key="'accordion'+accordionItem.requestId">
      <AdminItem
        v-if="data.type === 'admin'"
        :item="accordionItem"
        :itemId="'accordion'+index"
        :active="activeItemKey === 'accordion'+index"
        @clickCallback="itemClicked"
        v-show="accordionItem.requestStatus === selectedCategory"
        @closeAccordion="closeAccordion"
      />
      <SewistItem
        v-else-if="data.type === 'sewist'"
        :item="accordionItem"
        :itemId="'accordion'+index"
        :active="activeItemKey === 'accordion'+index"
        @clickCallback="itemClicked"
      />
      <!-- <CAAItem
        v-else-if="data.type === 'caa'"
        :item="accordionItem"
        :itemId="'accordion'+index"
        :active="activeItemKey === 'accordion'+index"
        @clickCallback="itemClicked"
      />-->
    </div>
  </div>
</template>

<script>
// import AccordionItem from "@/components/global/AccordionItem";
import { TweenLite } from "gsap/dist/gsap";
import AdminItem from "@/components/global/Accordion/AccordionTypes/AdminItem";
import SewistItem from "@/components/global/Accordion/AccordionTypes/SewistItem";
import CAAItem from "@/components/global/Accordion/AccordionTypes/CAAItem";
import AdminTableHeader from "@/components/global/Accordion/AccordionTypes/AdminTableHeader";
import SewistTableHeader from "@/components/global/Accordion/AccordionTypes/SewistTableHeader";
import Paginator from "@/components/Layout/Paginator";
import { mapState } from "vuex";
export default {
  name: "AccordionController",
  components: {
    AdminItem,
    CAAItem,
    SewistItem,
    AdminTableHeader,
    SewistTableHeader,
    Paginator
  },
  computed: {
    ...mapState(["global"])
  },
  data() {
    return {
      activeItemKey: ""
      // selectedCategoryLocal: null
    };
  },

  // watch:{
  //   selectedCategory: function(newVal, oldVal){
  //       this.filteredData = this.filterData(newVal);
  //       this.selectedCategoryLocal = newVal;
  //   }
  // },
  props: {
    data: {
      type: Object,
      required: true
    },
    selectedCategory: {
      type: String,
      required: false
    }
  },

  methods: {
    itemClicked(itemId) {
      let currentActiveEle = document.getElementById(this.activeItemKey);
      let activeItemKeyCopy = this.activeItemKey;
      if (currentActiveEle) {
        this.activeItemKey = "";
        currentActiveEle.classList.remove("min-content");

        TweenLite.to(currentActiveEle, 0.5, {
          height: 0
        });
      }
      if (itemId != activeItemKeyCopy) {
        this.activeItemKey = itemId;
        let newActiveEle = document.getElementById(itemId);
        TweenLite.to(newActiveEle, 0.5, {
          height: newActiveEle.scrollHeight
        });
        setTimeout(() => {
          newActiveEle.classList.add("min-content");
        }, 500);
      }
    },
    closeAccordion() {
      let currentActiveEle = document.getElementById(this.activeItemKey);

      if (currentActiveEle) {
        this.activeItemKey = "";
        currentActiveEle.classList.remove("min-content");

        TweenLite.to(currentActiveEle, 0.5, {
          height: 0
        });
      }
    }
  }
};
</script>

<style lang="scss">
.accordion {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: center;
  .how-renew-desc {
    text-align: center;
    font-family: "Brown-Regular";
    font-size: 16px;
    color: #000000;
    letter-spacing: 0;
    margin-bottom: 22px;
    width: 100%;
    b {
      color: #f00;
    }
  }
}
.accordion-controller {
  .admin-header-structure {
    border-bottom: 1px solid #efefef;
  }
  table {
    max-width: 100%;
    width: auto;
    flex: 1;
    display: grid;
    border-collapse: collapse;
    /* These are just initial values which are overriden using JavaScript when a column is resized */
  }

  thead,
  tbody,
  tr {
    display: contents;
  }

  th,
  td {
    padding: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 16px;
    @media (max-width: $md) {
      font-size: 14px;
    }
  }

  th {
    position: sticky;
    top: 0;
    background: #fff;
    text-align: left;
    font-weight: normal;
    font-size: 14px;
    text-transform: uppercase;
    color: #8b8795;
    position: relative;
    @media (max-width: $md) {
      font-size: 14px;
    }
  }

  th:last-child {
    border: 0;
  }

  .resize-handle {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    background: black;
    opacity: 0;
    width: 3px;
    cursor: col-resize;
  }

  .resize-handle:hover,
  /* The following selector is needed so the handle is visible during resize even if the mouse isn't over the handle anymore */
  .header--being-resized .resize-handle {
    opacity: 0.5;
  }

  th:hover .resize-handle {
    opacity: 0.3;
  }

  td {
    padding-top: 10px;
    padding-bottom: 10px;
    color: #808080;
  }

  tr:nth-child(even) td {
    background: #f8f6ff;
  }
}
.sewist-table-structure {
  grid-template-columns:
    minmax(auto, 35vw)
    minmax(auto, 17vw)
    minmax(auto, 14vw)
    minmax(auto, 10vw)
    minmax(auto, 8vw)
    minmax(auto, 8vw)
    minmax(auto, 8vw);
}

.admin-table-structure {
  grid-template-columns:
    minmax(auto, 25vw)
    minmax(auto, 10vw)
    minmax(auto, 15vw)
    minmax(auto, 7vw)
    minmax(auto, 6vw)
    minmax(auto, 7vw)
    minmax(auto, 25vw);
}
// .admin-table-structure {
//   grid-template-columns:
//     minmax(auto, 200px)
//     minmax(auto, 100px)
//     minmax(auto, 120px)
//     minmax(auto, 100px)
//     minmax(auto, 100px)
//     minmax(auto, 100px)
//     minmax(auto, 100px)
//     minmax(auto, 200px);
// }

// .admin-table-structure {
//   grid-template-columns:
//     minmax(auto, 2.2fr)
//     minmax(auto, 1fr)
//     minmax(auto, 1.3fr)
//     minmax(auto, 1fr)
//     minmax(auto, 1fr)
//     minmax(auto, 1fr)
//     minmax(auto, 1fr)
//     minmax(auto, 1.5fr);
// }

.admin-header-structure {
  grid-template-columns:
    minmax(auto, 2.2fr)
    minmax(auto, 1.67fr)
    minmax(auto, 1.67fr)
    minmax(auto, 1.67fr)
    minmax(auto, 1.67fr)
    minmax(auto, 1.67fr)
    minmax(auto, 3.33fr);
}
.min-content {
  height: min-content !important;
}
</style>